import type { EligibleDiscount } from '@library/api-promotions'

export type DiscountBadgeCopy = {
  collapsedText: string
  expandedText: string
}

const formatAmount = (amount: number): string =>
  `£${Number.isInteger(amount) ? amount : amount.toFixed(2)}`

export const formatDiscountBadge = (discount: EligibleDiscount): DiscountBadgeCopy | null => {
  const amount = Number(discount.amount)

  // A malformed amount would render "NaN% off" on a customer-facing badge; hide it instead.
  if (!Number.isFinite(amount)) {
    return null
  }

  const value = discount.type === 'percentageOffOrder' ? `${amount}%` : formatAmount(amount)

  return {
    collapsedText: `${value} off`,
    expandedText: `${value} discount applied`,
  }
}
